import { render } from "./DataCard.vue?vue&type=template&id=56453e4a&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"

import "./DataCard.vue?vue&type=style&index=0&id=56453e4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56453e4a"

export default script